import { ApiConfig } from '../../config/ApiConfig'
import { getRequestHeaders } from '../../utils/getRequestHeaders/getRequestHeaders'
import { getToken } from '../../utils/getToken/getToken'
import { AppStateWithData } from '../../redux/AppStateWithData'

export interface TagAutocompleteResult {
    value: string
    description: string
}

let tagsInputAutocompleteAbortController: AbortController | null = null
let tagsInputAutocompleteAbortSignal: AbortSignal | null = null

export const webGetTagsAutocomplete = (state: AppStateWithData, apiConfig: ApiConfig) => async (text: string): Promise<TagAutocompleteResult[]> => {
    if (tagsInputAutocompleteAbortController !== null) {
        tagsInputAutocompleteAbortController.abort()
    }

    const browserSupportsAbortion = "AbortController" in window
    if (browserSupportsAbortion) {
        tagsInputAutocompleteAbortController = new AbortController()
        tagsInputAutocompleteAbortSignal = tagsInputAutocompleteAbortController.signal
    }

    const url = `${apiConfig.API_URL}/autosuggest?query=${encodeURIComponent('#' + text)}`
    try {
        const response = await fetch(url, {
            signal: tagsInputAutocompleteAbortSignal,
            headers: getRequestHeaders(getToken(state))
        })
        const result = await response.json()
        return result
    } catch (e) {
        //TODO: what to do if autocomplete suggestion fails?
        return []
    }
}